import axiosInstance from "./axiosInstance";

const locationService = {
    getAllLocations: async () => {
        try {
            const response = await axiosInstance.get("/locations/all");
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    getLocationById: async (id) => {
        try {
            const response = await axiosInstance.get(`/locations/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    getLocationByWarehouse: async (warehouse) => {
        try {
            const response = await axiosInstance.get(`/locations/warehouse/${warehouse}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    createLocation: async (payload) => {
        try {
            const response = await axiosInstance.post("/locations/create", payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    updateLocation: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/locations/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    deleteLocation: async (id) => {
        try {
            const response = await axiosInstance.delete(`/locations/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default locationService;
